import { Actions } from './pieceGestionLigneActions';

/**
 * Etat initial
 */
const initialState = {
    pieceGestionLignes: {
        items: [],
        isLoading: false
    }
};

/**
 * Reducer pour les lignes de pièce gestion
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        // Fetch Piece gestion lignes.
        case Actions.FETCH_PIECE_GESTION_LIGNES_REQUEST:
            return {
                ...state,
                pieceGestionLignes: { ...state.pieceGestionLignes, isLoading: true }
            };
        case Actions.FETCH_PIECE_GESTION_LIGNES_SUCCESS:
            return {
                ...state,
                pieceGestionLignes: { items: [...action.pieceGestionLignes], isLoading: false }
            };
        case Actions.FETCH_PIECE_GESTION_LIGNES_FAILURE:
            return {
                ...state,
                pieceGestionLignes: { ...state.pieceGestionLignes, isLoading: false, error: action.error }
            }

        case Actions.CLEAR_PIECE_GESTION_LIGNES:
            {
                return {
                    ...state,
                    pieceGestionLignes: {
                        ...state.pieceGestionLignes,
                        items: []
                    }
                };
            }

        default:
    }

    return state;
}

export default reducer;